module.exports = __webpack_public_path__ + "static/img/amgo.3c35040a.png";